var echarts = require("../echarts");

require("./marker/MarkAreaModel");

require("./marker/MarkAreaView");

echarts.registerPreprocessor(function (opt) {
  // Make sure markArea component is enabled
  opt.markArea = opt.markArea || {};
});


//////////////////
// WEBPACK FOOTER
// ./~/_echarts@3.8.5@echarts/lib/component/markArea.js
// module id = 682
// module chunks = 115